var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container text-center p-3"},[_c('router-link',{staticClass:"navbar-brand mx-0",attrs:{"to":{ name: 'guest.home' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }